import {Injectable, signal} from '@angular/core';

/**
 * The title row of the topbar, set by the page on screen. Title and subtitle are translation keys, translated by the
 * topbar (`| translate`): a page sets them once, and a language change or a hard refresh's late translations follow by
 * themselves. A key with no translation shows as it is.
 */
@Injectable({providedIn: 'root'})
export class TopbarService {

	private readonly _title = signal('');
	private readonly _subtitle = signal('');
	private readonly _indicator = signal<string | undefined>(undefined);

	readonly title = this._title.asReadonly();
	readonly subtitle = this._subtitle.asReadonly();
	/** Shown as given next to the title (a count). */
	readonly indicator = this._indicator.asReadonly();

	setTitle(titleKey: string, subtitleKey: string, indicator?: string): void {
		this._title.set(titleKey);
		this._subtitle.set(subtitleKey);
		this._indicator.set(indicator);
	}
}
